import React from "react";
import { Info } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const ACCESS_OPTIONS = [
  "Yes, I will grant access",
  "Yes, but I need help setting it up",
  "No, I don't have one",
  "I'm not sure",
];

const AccessField = ({ label, helpText, field, value, onChange }) => (
  <div>
    <label className="block text-sm text-gray-300 mb-1.5">{label}</label>
    {helpText && (
      <p className="text-xs text-gray-500 mb-2 flex items-start gap-1.5">
        <Info className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#00B5E2]" />
        {helpText}
      </p>
    )}
    <Select value={value} onValueChange={(v) => onChange(field, v)}>
      <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid={`select-${field}`}>
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        {ACCESS_OPTIONS.map((opt) => (
          <SelectItem key={opt} value={opt}>{opt}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const PlatformAccessStep = ({ formData, onChange }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Platform Access</h2>
      <p className="text-gray-500 text-sm">Let us know which platforms you use so we can request access for analysis.</p>
    </div>

    <div className="bg-[#3056D3]/10 border border-[#3056D3]/20 rounded-xl p-4 text-sm text-gray-300 flex items-start gap-3">
      <Info className="w-5 h-5 text-[#00B5E2] shrink-0 mt-0.5" />
      <span>For each platform below, please grant access to <strong className="text-white">info@optimagrowth.agency</strong> so our team can review your current setup and performance data.</span>
    </div>

    <AccessField label="Do you have a Google Search Console account? *" helpText="If yes, please add info@optimagrowth.agency as a user." field="google_search_console" value={formData.google_search_console} onChange={onChange} />
    <AccessField label="Do you have a Google Analytics account? *" helpText="If yes, please add info@optimagrowth.agency as a user." field="google_analytics" value={formData.google_analytics} onChange={onChange} />
    <AccessField label="Do you have a Google Ads account? *" helpText="If yes, please grant access to info@optimagrowth.agency." field="google_ads" value={formData.google_ads} onChange={onChange} />
    <AccessField label="Do you have Meta Ads (Facebook/Instagram) accounts? *" helpText="If yes, please add info@optimagrowth.agency to manage them." field="meta_ads" value={formData.meta_ads} onChange={onChange} />
    <AccessField label="Do you run TikTok Ads? *" helpText="If yes, please provide access to info@optimagrowth.agency." field="tiktok_ads" value={formData.tiktok_ads} onChange={onChange} />
    <AccessField label="Do you currently use Google My Business? *" helpText="If yes, please provide access to info@optimagrowth.agency." field="google_my_business" value={formData.google_my_business} onChange={onChange} />
  </div>
);
